import { cn } from '@/renderer/lib/utils';
import React from 'react';

interface BillingMetricPillProps {
  hint?: string;
  icon?: React.ReactNode;
  label: string;
  value: string;
  tone?: 'default' | 'inverse';
}

export const BillingMetricPill: React.FC<BillingMetricPillProps> = ({
  hint,
  icon,
  label,
  value,
  tone = 'default',
}) => {
  const isInverse = tone === 'inverse';

  return (
    <div
      className={cn(
        'rounded-2xl border p-3',
        isInverse
          ? 'border-white/10 bg-white/10'
          : 'border-slate-200/80 bg-white/80',
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p
            className={cn(
              'text-[11px] font-medium uppercase tracking-[0.18em]',
              isInverse ? 'text-white/55' : 'text-slate-500',
            )}
          >
            {label}
          </p>
          <p
            className={cn(
              'mt-1 text-sm font-semibold',
              isInverse ? 'text-white' : 'text-slate-900',
            )}
          >
            {value}
          </p>
        </div>
        {icon && (
          <div
            className={cn(
              'mt-0.5 flex h-8 w-8 items-center justify-center rounded-xl',
              isInverse
                ? 'bg-white/10 text-white/80'
                : 'bg-emerald-50 text-emerald-600',
            )}
          >
            {icon}
          </div>
        )}
      </div>
      {hint && (
        <p
          className={cn(
            'mt-2 text-[11px]',
            isInverse ? 'text-white/60' : 'text-slate-500',
          )}
        >
          {hint}
        </p>
      )}
    </div>
  );
};
